module.exports = __webpack_public_path__ + "static/media/waiting-room-icon.46cf9bd8.svg";